import { Link } from 'react-router-dom'

const quickLinks = [
  { name: '课程列表', path: '/courses' },
  { name: '作品展示', path: '/gallery' },
  { name: '师资介绍', path: '/about' },
  { name: '教学文章', path: '/articles' },
]

const contactInfo = {
  phone: '17302483733',
  wechat: 'wanglaoshi_baking',
  email: '40384081@qq.com',
  address: '辽宁省沈阳市大东区滂江街22号龙之梦购物中心',
}

export default function Footer() {
  return (
    <footer className="bg-chocolate text-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.png" alt="王老师烘焙" className="w-12 h-12 rounded-full object-cover" />
              <div>
                <h3 className="font-display text-xl">王老师烘焙</h3>
                <p className="text-sm text-cream/70">专业西点培训20年</p>
              </div>
            </div>
            <p className="text-cream/80 leading-relaxed">
              传承法式烘焙技艺，专注于西点制作教学。20年烘焙经验，
              帮助数千名学员实现烘焙梦想。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg mb-6">快速链接</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-cream/80 hover:text-champagne transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display text-lg mb-6">联系我们</h4>
            <ul className="space-y-4 text-cream/80">
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 mt-0.5 text-champagne" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 mt-0.5 text-champagne" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>{contactInfo.email}</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 mt-0.5 text-champagne" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-cream/20 text-center text-cream/60 text-sm">
          <p>&copy; 2024 王老师烘焙. 保留所有权利.</p>
        </div>
      </div>
    </footer>
  )
}